export class Model {
  constructor(data?: Object) {
    Object.assign(this, data);
  }
}



// WEBPACK FOOTER //
// ./src/app/api/resources/model.ts